import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class NotificationStyleService {
  constructor(private httpClient: HttpClient) {}
  private notificationStyle: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private documentStyle: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  getActiveStyle() {
    return this.notificationStyle.value;
  }

  setActiveStyle(value: number) {
    this.notificationStyle.next(value);
  }

  getDocumentStyle() {
    return this.documentStyle.value;
  }

  setDocumentStyle(value: number) {
    this.documentStyle.next(value);
  }

}
